const cancelRefreshLoginRequest = () => (state) => {
  return Object.assign({}, state, {
    isLoading: false,
    isRefreshing: false,
    lastSuccessfulAuthentication: Date.now(),
  })
}

export default cancelRefreshLoginRequest
